import { useFormContext } from "react-hook-form";
import { FormField } from "@babackapp/ui/components/form";
import { ShopImportFormValues } from "./import-settings-form-types";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import FormOptionsSelector from "@babackapp/react-hook-forms-components/form-option-selector";

const AFTER_IMPORT_OPTIONS = [
  { key: "delete", label: "Delete the file" },
  { key: "rename", label: "Keep it, renamed .ok / .nok" },
];

export default function ImportOptionsForm() {
  return (
    <div className="flex flex-col gap-8">
      <DelimiterInput />
      <WithHeaderSwitch />
      <FileToImportFilterRegexInput />
      <AfterImportSelector />
    </div>
  );
}

function DelimiterInput() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.delimiter"
      control={control}
      render={({ field }) => (
        <FormInput
          label="Delimiter"
          description="Delimiter used in the file"
          {...field}
        />
      )}
    />
  );
}

function WithHeaderSwitch() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.withHeader"
      control={control}
      render={({ field }) => (
        <FormSwitch
          label="With Header"
          description="Whether the file has a header row"
          {...field}
        />
      )}
    />
  );
}

function FileToImportFilterRegexInput() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.fileToImportFilterRegex"
      control={control}
      render={({ field }) => (
        <FormInput
          label="File to Import Filter Regex"
          description="Regex to filter files to import"
          {...field}
        />
      )}
    />
  );
}

function AfterImportSelector() {
  const { control } = useFormContext<ShopImportFormValues>();

  return (
    <FormField
      name="options.settings.afterImport"
      control={control}
      render={({ field }) => (
        <FormOptionsSelector
          label="After import"
          description="What happens to the file on your server once imported. Kept files become name.processing, then name.ok when every line went through, or name.nok otherwise."
          value={field.value ?? "delete"}
          options={AFTER_IMPORT_OPTIONS}
          onChange={(value) => field.onChange(value)}
        />
      )}
    />
  );
}
